export function getLogout(setCurrentUser) {
  return async () => {
    localStorage.clear('currentUser');
    await setCurrentUser(null);
  }
}